import { axiosInstance } from '@/utils/libs/axios';
import { useMutation } from '@tanstack/react-query';

export const MinioService = {
  useDownloadFile: () =>
    useMutation({
      mutationFn: async (originalUrl: string) => {
        const response = await axiosInstance.get(originalUrl, {
          responseType: 'blob',
        });

        return response.data;
      },
    }),
};
